import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "@/lib/supabaseClient";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [status, setStatus] = useState({ key: "authCallback.verifyingEmail" });

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const {
          data: { session },
          error: sessionError,
        } = await supabase.auth.getSession();

        if (sessionError || !session) {
          setStatus({ key: "authCallback.invalidSession" });
          setTimeout(() => navigate("/login"), 2000);
          return;
        }

        setStatus({ key: "authCallback.emailConfirmed" });

        const res = await fetch("/api/check-subscription", {
          headers: { Authorization: `Bearer ${session.access_token}` },
        });
        const subscriptionData = await res.json();

        if (subscriptionData?.hasSubscription) {
          setStatus({ key: "authCallback.subscriptionFound" });
          localStorage.removeItem("pendingEmail");
          localStorage.removeItem("pendingPlan");
          setTimeout(() => navigate("/profile"), 1000);
          return;
        }

        setStatus({ key: "authCallback.redirectPayment" });
        setTimeout(() => navigate("/subscription-required"), 1000);
      } catch (err) {
        console.error("Auth callback error:", err);
        setStatus({ key: "authCallback.error", values: { message: err.message } });
        setTimeout(() => navigate("/login"), 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50">
      <div className="bg-white p-8 rounded-2xl shadow-sm text-center max-w-md">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black mx-auto mb-4" />
        <p className="text-neutral-900 font-medium text-lg mb-2">
          {t(status.key, status.values)}
        </p>
        <p className="text-sm text-neutral-500">{t("authCallback.pleaseWait")}</p>
      </div>
    </div>
  );
}
